<script setup lang="ts">
import { ref, computed, onBeforeMount, onMounted, watch } from 'vue'
import { useCommonStore } from '~/stores/common'
import { useRoute, useRouter } from 'vue-router'
import { useFetch, useRuntimeConfig } from 'nuxt/app' 
import { useSeoMeta } from '@unhead/vue'
import { definePageMeta, showError, useHead } from '~/.nuxt/imports'
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import Management from '~/components/management/Management.vue'

const commonStore = useCommonStore()

definePageMeta({
    layout: 'main',
    middleware: ['auth']
})

useSeoMeta({
    title: () => `Менеджмент компании — AKTIVO`,
    description: () => `Менеджмент компании AKTIVO. Наша цель — сделать для вас процесс инвестирования простым, понятным и доступным.`
})

const management = ref({
    oscarhartmann: {
        name: 'Оскар Хартманн',
        post: 'Президент компании Aktivo'
    },
    egorklimenko: {
        name: 'Егор Клименко',
        post: 'Генеральный директор Aktivo',
    },
    konstantinzemskov: {
        name: 'Константин Земсков',
        post: 'Заместитель Генерального директора'
    },
    mihailkostromin: {
        name: 'Михаил Костромин',
        post: 'Коммерческий директор AKTIVO'
    }
})

onMounted(() => {
    commonStore.setTheme('white')
    commonStore.setLoadingStatus(false)
})
</script>

<template>
    <Breadcrumbs  :data="[{ name: 'О компании', link: '/about' }, { name: 'Менеджмент компании AKTIVO' }]" />
    <Management :data="management" />
</template>